(function () {
  if (!/\/blogs\/[^/]+\/(goth-style|goth-style-conversion-draft-reviewed)$/.test(window.location.pathname)) return;

  var articleHandle = "goth-style";
  var contentGroup = "goth_style_article";

  function analyticsAllowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (privacy && typeof privacy.analyticsProcessingAllowed === "function") {
      return privacy.analyticsProcessingAllowed();
    }
    return true;
  }

  function sendEvent(name, parameters) {
    if (!analyticsAllowed()) return;

    if (typeof window.gtag === "function") {
      window.gtag("event", name, parameters);
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, parameters));
  }

  function productData(card, index) {
    var title = card.querySelector("strong");
    var priceMatch = card.textContent.match(/From\s+\$([\d.]+)/i);
    var item = {
      item_id: card.dataset.itemId || "",
      item_name: title ? title.textContent.trim() : card.textContent.trim(),
      index: index,
    };

    if (priceMatch) item.price = Number(priceMatch[1]);
    return item;
  }

  function init() {
    document.addEventListener("click", function (event) {
      var link = event.target.closest("[data-goth-article-link]");
      if (!link) return;

      var placement = link.dataset.placement || "unknown";
      var common = {
        content_group: contentGroup,
        placement: placement,
        article_handle: articleHandle,
      };

      if (link.dataset.contentType === "goth_article_product") {
        var module = link.closest("[data-goth-article-module]");
        var cards = module ? Array.from(module.querySelectorAll("[data-goth-article-link]")) : [link];
        var listName = module ? module.querySelector("h3") : null;
        sendEvent("select_item", Object.assign({}, common, {
          item_list_id: "goth_article_" + (module ? module.dataset.gothArticleModule : "products"),
          item_list_name: listName ? listName.textContent.trim() : "Goth article products",
          items: [productData(link, Math.max(cards.indexOf(link), 0))],
        }));
        return;
      }

      sendEvent("select_content", Object.assign({}, common, {
        content_type: link.dataset.contentType || "goth_article_pathway",
        item_id: link.dataset.itemId || link.getAttribute("href") || "",
        item_name: link.textContent.trim(),
      }));
    });

    if (!("IntersectionObserver" in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || entry.intersectionRatio < 0.5) return;

        var module = entry.target;
        var cards = Array.from(module.querySelectorAll("[data-goth-article-link]"));
        var heading = module.querySelector("h3");
        var moduleName = module.dataset.gothArticleModule || "products";

        sendEvent("view_item_list", {
          item_list_id: "goth_article_" + moduleName,
          item_list_name: heading ? heading.textContent.trim() : "Goth article products",
          content_group: contentGroup,
          placement: moduleName + "_product_module",
          article_handle: articleHandle,
          items: cards.map(productData),
        });
        observer.unobserve(module);
      });
    }, { threshold: [0.5] });

    function observeModules(root) {
      root.querySelectorAll("[data-goth-article-module]").forEach(function (module) {
        if (module.dataset.gothArticleObserved) return;
        module.dataset.gothArticleObserved = "true";
        observer.observe(module);
      });
    }

    observeModules(document);
    document.addEventListener("shopify:section:load", function (event) {
      observeModules(event.target);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
